// Initial state
const state = {
// tabExpand, tabHorizontal, tabVertical
  tabVersion: 'tabVertical'
}

// The getters, to...get... data from the state
const getters = {
  tabVersion: state => {
    return state.tabVersion
  }
}

const mutations = {
  mutateTabVersion (state, status) {
    state.tabVersion = status
  }
}

// Basically like methods, but you aren't allowed to modify the state directly, only through committing mutations
const actions = {
  updateTabVersion ({ commit }, newValue) {
    commit('mutateTabVersion', newValue)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
